import {ClipboardPaste} from "lucide-react";
import {i18n} from "../../../shared/i18n";


export const AppTextsJsonEditor = ({
    label = i18n.t("sections.content.p114"),
    value,
    onChange,
    parseError,
    fieldErrors = [],
    readOnly,
    baseTitle = i18n.t("sections.content.p115"),
    baseJson,
    effectiveTitle = i18n.t("sections.content.p116"),
    effectiveJson,
    effectiveNote = null,
    insertLabel = i18n.t("sections.content.p117"),
    onInsertBase,
}) => (
    <div className="content-texts-json">
        <div className="content-texts-json-editor">
            <label className="admin-field content-texts-json-field">
                <span>{label}</span>
                <textarea
                    aria-invalid={parseError ? "true" : undefined}
                    aria-label={label}
                    className="admin-textarea content-texts-code"
                    disabled={readOnly}
                    onChange={(event) => onChange(event.target.value)}
                    placeholder="{}"
                    spellCheck={false}
                    value={value}
                />
            </label>
            {parseError ? <p className="content-field-error">{i18n.t("sections.content.p118")} {parseError}</p> : null}
            {fieldErrors.length ? (
                <ul className="content-texts-field-errors">
                    {fieldErrors.map((item) => item.messages.map((message) => (
                        <li className="content-field-error" key={`${item.path}-${message}`}><code>{item.path}</code> {message}</li>
                    )))}
                </ul>
            ) : null}
            {onInsertBase && !readOnly ? (
                <div className="content-row-actions">
                    <button className="admin-row-action" onClick={onInsertBase} type="button"><ClipboardPaste size={14} /> {insertLabel}</button>
                </div>
            ) : null}
        </div>
        <div className="content-texts-json-panes">
            <section aria-label={baseTitle}>
                <h4>{baseTitle}</h4>
                <pre>{baseJson || "—"}</pre>
            </section>
            <section aria-label={effectiveTitle} className={effectiveNote ? "is-pending" : undefined}>
                <h4>{effectiveTitle}{effectiveNote ? <small> · {effectiveNote}</small> : null}</h4>
                <pre>{effectiveJson || "—"}</pre>
            </section>
        </div>
    </div>
);
